export const HASH_CODE_REGEX = /^[A-Z0-9]{8}$/
